import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type UserProfile = {
  id: string;
  email: string;
  full_name: string | null;
  firma_kodu: string | null;
  firma_ismi: string | null;
  telefon: string | null;
  city: string | null;
  country: string | null;
  website: string | null;
  bio: string | null;
  referral_code: string | null;
  created_at: string;
};

export async function getUserProfile(): Promise<UserProfile | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase
    .from('sk_users')
    .select('*')
    .eq('id', user.id)
    .maybeSingle();

  const meta = user.user_metadata || {};
  if (error) {
    console.error('getUserProfile error:', error);
    return null;
  }

  if (data) {
    return {
      id: data.id,
      email: user.email || '',
      full_name: meta.full_name || null,
      firma_kodu: data.firma_kodu,
      firma_ismi: data.firma_ismi,
      telefon: data.telefon,
      city: data.city,
      country: data.country,
      website: data.website,
      bio: data.bio,
      referral_code: data.referral_code || null,
      created_at: data.created_at,
    };
  }

  return {
    id: user.id,
    email: user.email || '',
    full_name: meta.full_name || null,
    firma_kodu: null,
    firma_ismi: null,
    telefon: null,
    city: null,
    country: null,
    website: null,
    bio: null,
    referral_code: null,
    created_at: user.created_at || '',
  };
}